
import { Wand2, CheckCircle2 } from "lucide-react";

const Stats = () => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-8 text-gray-600">
      <div className="flex items-center gap-2.5 group">
        <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-primary/5 transition-colors">
          <Wand2 className="w-5 h-5 text-primary" />
        </div>
        <span className="text-sm font-medium">10,000+ Recipes Converted</span>
      </div>
      <div className="flex items-center gap-2.5 group">
        <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-primary/5 transition-colors">
          <CheckCircle2 className="w-5 h-5 text-primary" />
        </div>
        <span className="text-sm font-medium">Trusted by Thousands</span>
      </div>
    </div>
  );
};

export default Stats;
